import { motion, AnimatePresence } from "framer-motion";
import { Ticket, Barbell, QrCode, ArrowRight, X } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";

const steps = [
  {
    icon: Ticket,
    title: "Compre seu Ingresso",
    desc: "Escolha entre entrada única, passaporte mensal ou anual VIP. Pague via PIX ou cartão.",
    color: "from-[#FF5A26] to-[#E04818]",
  },
  {
    icon: Barbell,
    title: "Reserve Esportes Grátis",
    desc: "Futsal, Capoeira, Jiu-Jitsu e mais — tudo gratuito para membros do clube!",
    color: "from-[#10B981] to-[#059669]",
  },
  {
    icon: QrCode,
    title: "Apresente seu QR Code",
    desc: "Após a compra, seu ingresso digital com QR Code é gerado na hora. Só mostrar na portaria!",
    color: "from-[#0891B2] to-[#0E7490]",
  },
];

const Onboarding = ({ onComplete }) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4"
      data-testid="onboarding-modal"
    >
      <motion.div
        initial={{ scale: 0.9, y: 30 }}
        animate={{ scale: 1, y: 0 }}
        className="bg-white rounded-3xl max-w-lg w-full p-8 relative"
      >
        <button
          onClick={onComplete}
          className="absolute top-4 right-4 text-[#115E59] hover:text-[#042F2E]"
          data-testid="onboarding-close"
        >
          <X size={24} />
        </button>

        <h2 className="text-2xl font-black text-[#042F2E] text-center mb-2">
          Bem-vindo ao MARABU!
        </h2>
        <p className="text-center text-[#115E59] mb-8">
          Veja como aproveitar ao máximo
        </p>

        <div className="space-y-5">
          {steps.map((step, i) => {
            const Icon = step.icon;
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: i * 0.15 }}
                className="flex items-start gap-4"
                data-testid={`onboarding-step-${i}`}
              >
                <div
                  className={`w-12 h-12 rounded-xl bg-gradient-to-br ${step.color} flex items-center justify-center shrink-0`}
                >
                  <Icon size={24} weight="fill" className="text-white" />
                </div>
                <div>
                  <h3 className="font-bold text-[#042F2E]">{step.title}</h3>
                  <p className="text-sm text-[#115E59]">{step.desc}</p>
                </div>
              </motion.div>
            );
          })}
        </div>

        <Button
          onClick={onComplete}
          className="w-full bg-[#FF5A26] hover:bg-[#E04818] text-white font-bold rounded-full py-6 text-lg mt-8"
          data-testid="onboarding-start"
        >
          Começar <ArrowRight size={20} weight="bold" className="ml-2" />
        </Button>
      </motion.div>
    </motion.div>
  );
};

export default Onboarding;
